<template lang='pug'>
.md-layout(style='padding-left: 20px; height: 100%;')
  .md-layout-item
    v-row(v-if='loading' style='height: 100%; justify-content: center; align-items: center')
      v-col(cols='auto')
        v-progress-circular(
          size='120'
          width='4'
          indeterminate
          color='rgba(200, 200, 200, 0.7)')
          b(style='font-size: 14px; color: rgba(200, 200, 200, 0.7)') {{$t('selectWorkspaces.loading')}}
    v-row(v-else)
      v-col(
        xl='3'
        lg='3'
        md='6'
        sm='12'
        xs='12'
        @click='selectWorkspace(workspace)'
        v-for='(workspace, i) in workspaces',
        :key='i')
        md-card.md-card-chart(
          :class='{ "item-selected": workspaceActive === workspace.name }'
          style='margin: 0; height: 100%; cursor: pointer; background-color: #fafafa')
          md-card-header.animated.md-card-header-text(
            style='background: linear-gradient(60deg, #66bb6a, #43a047);')
            .social-line
              v-row(no-gutters style='padding: 0 8px;')
                v-col(
                  style='padding: 0; align-self: center; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; color: white;')
                  h4.title(
                    :title='workspace.name'
                    style='display: inline; color: white;')
                    | {{ workspace.name }}
          md-card-content
            h4.title
              b {{ workspace.description }}
            //- h4.title
            //-   b Tipo:
            //-   |
            //-   | {{ workspace.type }} - {{ workspace.language }}
            //- h4.title
            //-   b Criado em:
            //-   |
            //-   | {{ workspace.created }}
          //- md-card-actions(md-alignment='left')
          //-   .stats
          //-     md-icon access_time
          //-     | atualizado &agrave;&nbsp;
          //-     AnimatedNumber(:value='getDate(workspace.updated).value')
          //-     | &nbsp;{{ evaluateType(getDate(workspace.updated).value, getDate(workspace.updated).type) }}
</template>

<script>
import AnimatedNumber from '@/components/AnimatedNumber'
import { mapGetters } from 'vuex'
export default {
  name: 'SelectWorkspace',
  components: {
    AnimatedNumber
  },
  computed: {
    ...mapGetters('workspaces', ['workspaces'])
  },
  data () {
    return {
      workspaceActive: null,
      loading: true
    }
  },
  methods: {
    selectWorkspace (workspace) {
      this.workspaceActive = workspace.name
      this.$emit('selected-workspace', workspace)
    },
    evaluateType (value, type) {
      if (type === 'seconds') {
        return value === 1 ? this.$t('selectWorkspaces.second') : this.$t('selectWorkspaces.seconds')
      } else if (type === 'minutes') {
        return value === 1 ? this.$t('selectWorkspaces.minute') : this.$t('selectWorkspaces.minutes')
      } else if (type === 'hours') {
        return value === 1 ? this.$t('selectWorkspaces.hour') : this.$t('selectWorkspaces.hours')
      } else {
        return value === 1 ? this.$t('selectWorkspaces.day') : this.$t('selectWorkspaces.days')
      }
    },
    getDate (updated) {
      let d1 = new Date() // Mon Jun 29 2020 20:37:09 GMT-0300 (Horário Padrão de Brasília)
      let arr = updated.split(' ') // Mar 24 2015 21:00:00 GMT-0300 (Horário Padrão de Brasília)
      let aux =
        arr[2] +
        ' ' +
        arr[0] +
        ' ' +
        arr[4] +
        ' ' +
        arr[6] +
        ' GMT' +
        arr[7] +
        '00'
      let d2 = new Date(aux) // 28 de Jun de 2020 às 17:26 -03
      const diffTime = Math.abs(d1 - d2) / 1000
      if (diffTime < 60) {
        return {
          value: diffTime,
          type: 'seconds'
        }
      } else if (diffTime < 60 * 60) {
        return {
          value: Math.floor(diffTime / 60),
          type: 'minutes'
        }
      } else if (diffTime < 60 * 60 * 24) {
        return {
          value: Math.floor(diffTime / (60 * 60)),
          type: 'hours'
        }
      } else {
        return {
          value: Math.floor(diffTime / (60 * 60 * 24)),
          type: 'days'
        }
      }
    }
  },
  async created () {
    this.loading = true
    // console.log('create')
    await this.$store.dispatch('workspaces/populate')
    // console.log('populate')
    this.loading = false
  }
}
</script>

<style scoped>
/* .md-button.md-warning.access-workspace {
  background-color: #e0e0e0 !important;
} */
.md-button .access-workspace {
  background-color: #e0e0e0 !important;
}
.md-button .access-workspace:hover,
.md-button .access-workspace:focus,
.md-button .access-workspace:active,
.md-button .access-workspace.active,
.md-button .access-workspace:active:focus,
.md-button .access-workspace:active:hover,
.md-button .access-workspace.active:focus,
.md-button .access-workspace.active:hover {
  background-color: #e0e0e0 !important;
  color: #fff !important;
  -webkit-box-shadow: 0 14px 26pxnode -12px rgba(59, 89, 152, 0.42),
    0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2) !important;
  box-shadow: 0 14px 26px -12px rgba(59, 89, 152, 0.42),
    0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2) !important;
}
.title {
  font-size: 1rem;
  line-height: 1.2em;
}
.item-selected {
  border-radius: 7px;
  border: 2px solid #9c27b0;
  box-shadow: 0px 5px 10px 0px #8d8d8d;
}
</style>
